module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">App Instance</span></div>\r\n<div class=\"row\">\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"none\" checked=\"checked\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">New instance</label>\r\n	</div>\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"existing2\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">Existing instance</label>\r\n	</div>\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"new\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">New child instance</label>\r\n	</div>\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"single\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">Single child instance</label>\r\n	</div>\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"existing\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">Existing child instance</label>\r\n	</div>\r\n	<div class=\"col-md-12 form-group-flex\">\r\n		<input type=\"radio\" name=\"parentChild\" value=\"parent\" class=\"form-radio-group\"/>\r\n		<label class=\"form-group-label\">Parent instance</label>\r\n	</div>\r\n</div>")
  }
  return __output;

}